import React from 'react'
import { makeStyles } from '@mui/styles'
import Radio from '@mui/material/Radio'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  wrapper: (props) => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: props.isOnboarding ? 0 : 24,

  }),
  radioLabel: (props) => ({
    fontWeight: theme.fontWeights.medium,
    fontSize: theme.fontSizes.default,
    color: props.readOnly ? theme.disabledColor : props.isOnboarding ? theme.primary : theme.text,
    cursor: 'pointer',
    '&:hover': {
      color: props.hover ? theme.primary : null,
    },
  }),
  radioDescription: (props) => ({
    color: props.readOnly && theme.disabledColor,
    marginTop: 10,
    display: 'block',
  }),
  radioLabelWrapper: (props) => ({
    marginLeft: props.isOnboarding ? 10 : 20,
    fontSize: 14,
  }),
}))

export default function SettingsRadioInput(props) {
  const {
    value,
    checked,
    title,
    description,
    descriptionComponent,
    onChange = () => {},
    children,
    readOnly,
    className,
    dangerouslySetInnerHTML,
  } = props
  const classes = useStyles(props)

  const handleChange = () => {
    onChange && onChange(value)
  }

  let descriptionEle = null
  if (description) {
    descriptionEle = dangerouslySetInnerHTML
      ? <label className={classes.radioDescription} htmlFor={value} dangerouslySetInnerHTML={{ __html: description }} />
      : <label className={classes.radioDescription} htmlFor={value}>{description}</label>
  }

  return (
    <div className={clsx(classes.wrapper, className)}>
      <div className={classes.radioInput}>
        <Radio
          id={value}
          checked={checked}
          onChange={handleChange}
          value={value}
          color='primary'
          size='small'
          disabled={readOnly}
        />
      </div>
      <div className={classes.radioLabelWrapper} >
        <label className={classes.radioLabel} htmlFor={value}>{title}</label>
        {descriptionEle}
        {descriptionComponent}
        {children}
      </div>
    </div>
  )
}
SettingsRadioInput.propTypes = {
  value: PropTypes.any,
  className: PropTypes.string,
  checked: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string.isRequired,
  ]),
  description: PropTypes.string,
  descriptionComponent: PropTypes.node,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  isOnboarding: PropTypes.bool,
  dangerouslySetInnerHTML: PropTypes.bool,
}
